import axios, { AxiosResponse } from 'axios';
import { ApiResponse, GetReportResponse, zps_wp } from '../zps';
import { IUser } from '../user';
import { MeansCash } from '../transactions';
import { handleDownload } from '../../app/utils/script';

export type Totals = {
  cid: number;
  total: number;
  paid: number;
  paidAP: number;
  cashOut?: MeansCash[];
};

export type PeriodTotals = {
  gid: number;
  eid: number;
  period: number;
  dateTimeOpen: string;
  dateTimeClose: string;
  closeCode: number;
  totals: Totals[];
  mc: MeansCash[];
  userOpen?: IUser;
  userClose?: IUser;
  useReport?: boolean;
  code?: number;
  sid?: number;
  equiType?: number;
  //
  amountCollum: Totals; // auxiliary
  userCollum: string; // auxiliary
};

export const fetchPeriodsTotals = (
  entid: number,
  sid: number,
  eid: number,
  offset: number,
  limit: number,
  totalRows: boolean,
  controller: AbortController,
  begin?: string,
  end?: string,
  period?: number
): Promise<AxiosResponse<PeriodTotals[]>> => {
  let url =
    `${zps_wp}/api/v2/periodTotals?entid=${entid}&offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    `${begin ? '&begin=' + begin : ''}` +
    `${end ? '&end=' + end : ''}` +
    `${sid ? '&sid=' + sid : ''}` +
    `${eid ? '&eid=' + eid : ''}` +
    `${period ? '&period=' + period : ''}`;

  return axios.get<PeriodTotals[]>(url, { signal: controller.signal });
};

export const fetchEquipmentPeriodReport = async (
  format: string,
  eid: number,
  period: number,
  controller: AbortController
): Promise<ApiResponse> => {
  const res = await axios.get<GetReportResponse>(
    `${zps_wp}/api/v2/periodTotals/report?format=${format}&eid=${eid}&period=${period}`,
    { signal: controller.signal }
  );
  if (res.data?.statusOper?.code !== 0) {
    const e: any = new Error(res.data.statusOper.message);
    e.statusOper = res.data.statusOper;
    throw e;
  }

  handleDownload(res.data.report, res.data.name, res.data.mime);

  return res.data;
};
